// Focus trap mixin for modals — traps Tab/Shift+Tab within the modal
// container and returns focus to the trigger element when the modal
// closes. Follows WCAG 2.4.3 and ARIA Authoring Practices.
//
// Usage: add `mixins: [focusTrapMixin]` to your modal component.
// The component's root element (this.$el) is used as the trap container.
// Call `this.activateFocusTrap()` in mounted/created and
// `this.deactivateFocusTrap()` in beforeDestroy.

const FOCUSABLE = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])'
].join(', ');

export default {
  data() {
    return {
      _focusTrapPreviousActiveElement: null
    };
  },
  methods: {
    activateFocusTrap() {
      this._focusTrapPreviousActiveElement = document.activeElement;
      this.$nextTick(() => {
        if (!this.$el) return;
        // Focus the first focusable element inside the modal
        const first = this.$el.querySelector(FOCUSABLE);
        if (first) first.focus();
        document.addEventListener('keydown', this._onFocusTrapKeydown);
      });
    },
    deactivateFocusTrap() {
      document.removeEventListener('keydown', this._onFocusTrapKeydown);
      // Return focus to the element that opened the modal
      if (
        this._focusTrapPreviousActiveElement &&
        this._focusTrapPreviousActiveElement.focus
      ) {
        this.$nextTick(() => {
          try {
            this._focusTrapPreviousActiveElement.focus();
          } catch (e) {
            /* noop */
          }
        });
      }
    },
    _onFocusTrapKeydown(e) {
      if (e.key !== 'Tab' || !this.$el) return;
      const focusable = Array.from(this.$el.querySelectorAll(FOCUSABLE));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  }
};
